import { createContext, useContext } from 'react';

export const InstallDismantleContext = createContext(null);

export const useInstallDismantle = () => useContext(InstallDismantleContext);
